import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';
import { useCreateAccount } from '../../../../hooks';

const { NAME, API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const DynCreateModal = () => {
  const { createAccount } = useCreateAccount();
  return (
    <CreateModalRHF headerText="Connect Dyn account" onSubmit={createAccount}>
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      <ConnectedInputField name={API_KEY} labelText="API key" data-test="apiKey-input" />
    </CreateModalRHF>
  );
};
